export default "__VITE_ASSET__072697bf__"